import {
	Button,
} from '@apostrophe/ui';
import styled, { css } from 'styled-components';
import {
	media,variables
} from 'styleUtils';


const CreditCardInputWrapper = styled.div`
  /* border-radius: 4px; */
  font-family: "Maax";
  cursor: pointer;
  width: 100%;
  background-color: ${props => props.darkMode ? variables.lightGrey : variables.white};
  box-shadow: 0px 2px 4px rgb(51 51 51 / 8%);
  
  ${props => props.withBorder && `
    border: 4px solid ${variables.yellow};
  `}

  ${props => props.otcCheckout && css`
    font-size: 18px;
  `}

  ${props => props.isPrepay && css`
    box-shadow: none;
    border: 1px solid ${variables.midGrey};
    border-radius: 8px;
  `}  
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  button {
    padding: 20px 28px;
    border-radius: 2rem;
  }
`

const Error = styled.div`
  min-height: 24px;
  color: ${variables.error};
  font-size: .75rem;
  ${props => props.medCheckout && 'min-height: unset; height: auto;'}
`


const Disclaimer = styled.div`
  margin-top: 36px;
  text-align: center;
  font-size: 9px;
  font-style: italic;
  ${media.smallTablet`
    padding: 0px 100px;
  `}

  padding: 0px 20px;
`

const StyledButton = styled(Button)`
width: 100%;
  height: 44px;

	${media.tablet`
  width: 190px;
    `}
}`


const UpdatedRegistrationButtonWrapper = styled.div`
	margin-top: 24px;
	margin-bottom: 24px;
`


export {
	ButtonWrapper,
	CreditCardInputWrapper,
	Disclaimer,
	Error,
	StyledButton,
	UpdatedRegistrationButtonWrapper,
}
